export const metadata = {
	company: {
		name: 'Akonia Codex',
		tagline: 'Learn to build with AI, or let us build for you',
		description: 'We teach developers how to work with AI as their coding partner, and we build products for people who need to ship.',
		email: 'hello@akoniacodex.com',
		website: 'https://www.akoniacodex.com',
		calendlyUrl: 'https://calendly.com/aliahammadpk/30min'
	},
	social: {
		linkedin: 'https://linkedin.com/company/akonia-codex',
		personalLinkedin: 'https://www.linkedin.com/in/ahammadalipk/',
		twitter: 'https://twitter.com/akoniacodex',
		youtube: 'https://www.youtube.com/@akoniacodex',
		instagram: 'https://www.instagram.com/akoniacodex/',
		github: 'https://github.com/akoniacodex'
	},
	seo: {
		titleTemplate: '%s | Akonia Codex',
		defaultTitle: 'Akonia Codex | Learn Spec-Driven Development & AI Coding Frameworks',
		defaultDescription: 'Master Agentic AI and spec-driven development. We teach engineers to build with AI and provide elite software engineering services for MVPs and complex systems.',
		keywords: ['Agentic AI', 'AI Software Engineering', 'Spec-Driven Development', 'BMAD Method', 'LLM Engineering', 'AI Agents', 'MVP Development', 'AI Developer Training', 'Cursor AI', 'GitHub Copilot', 'AI Code Hallucinations', 'Claude CLI', 'Claude Code', 'Anthropic Claude']
	}
};
